var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'uk-label uk-label-'+_vm.type + _vm.generateClasses(),attrs:{"uk-tooltip":_vm.tooltip? 'title:'+_vm.tooltip : ''}},[(_vm.icon)?_c('IconText',{attrs:{"has-text":_vm.text !== undefined,"icon":_vm.icon}},[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2):_c('span',[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }